import React from 'react';
import { Skeleton } from '../ui';

const StatCardSkeleton: React.FC = () => (
  <div className="au-stat-card">
    <div className="flex items-center justify-between mb-4">
      <Skeleton variant="rounded" width={40} height={40} />
      <Skeleton variant="rounded" width={60} height={24} />
    </div>
    <div>
      <Skeleton variant="text" width="50%" height={14} className="mb-2" />
      <Skeleton variant="text" width="40%" height={32} className="mb-2" />
      <Skeleton variant="text" width="70%" height={12} />
    </div>
  </div>
);

const DashboardSkeleton: React.FC = () => (
  <div className="py-6 animate-fade-in">
    {/* Page Header Skeleton */}
    <div className="mb-8">
      <Skeleton variant="text" width={250} height={36} className="mb-2" />
      <Skeleton variant="text" width={400} height={16} />
    </div>

    {/* Stats Grid Skeleton */}
    <div className="au-dashboard-grid">
      <StatCardSkeleton />
      <StatCardSkeleton />
      <StatCardSkeleton />
    </div>
  </div>
);

export { DashboardSkeleton, StatCardSkeleton };
export default DashboardSkeleton;
